var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Suspense } from 'react';
import LoadingPlaceholder from '~/components/loading-placeholder/loading-placeholder';
// importFn is a promise returning a function whose parameters are type T
// componentParams are those parameters
export default function JITLoad(_a) {
    var { importFn } = _a, componentParams = __rest(_a, ["importFn"]);
    const Component = React.useMemo(() => React.lazy(importFn), [importFn]);
    return (React.createElement(Suspense, { fallback: React.createElement(LoadingPlaceholder, null) },
        React.createElement(Component, Object.assign({}, componentParams))));
}
